/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { textCustomComparator } from '../../../contactType/components/tableHead';
import * as Styles from './StyleConstant';

export const CODE_DOMAIN_CELL_HEAD = [
  {
    headerName: 'Code Domain Key',
    field: 'codeDomainKey',
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Short Description',
    field: 'shortDescription',
    cellRenderer: 'textFieldComponent',
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_250,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Long Description',
    field: 'longDescription',
    cellRenderer: 'textFieldComponent',
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_250,
    maxLength: Styles.Length_255,
    resizable: false,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
    // }]
  },
];
export const CODE_VALUE_CELL_HEAD = [
  {
    headerName: 'Actions',
    cellRenderer: 'deleteBoxRenderer',
    filter: false,
    sortable: false,
    suppressMenu: false,
    minWidth: Styles.Width_100,
    resizable: false,
    maxWidth: Styles.Width_100,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    pdfExportOptions: {
      skipColumn: true,
    },
  },
  {
    headerName: 'Code Domain Key',
    field: 'codeValueID.codeDomainKey',
    suppressMenu: false,
    minWidth: Styles.Width_180,
    sortable: true,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Code Value',
    field: 'codeValueID.codeValue',
    required: true,
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      disabled: false,
      required: true,
      maxLength: 10,
    },
    sortable: true,
    suppressMenu: false,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    minWidth: Styles.Width_180,
    maxWidth: Styles.Width_180,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Short Description',
    field: 'shortDescription',
    cellRenderer: 'textFieldComponent',
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_100,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Long Description',
    field: 'longDescription',
    cellRenderer: 'textFieldComponent',
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
];

export const CODE_VALUE_CELL_HEAD_DISABLE = [
  {
    headerName: 'Actions',
    cellRenderer: 'deleteBoxRenderer',
    filter: false,
    sortable: false,
    suppressMenu: false,
    minWidth: Styles.Width_100,
    resizable: false,
    maxWidth: Styles.Width_100,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    pdfExportOptions: {
      skipColumn: true,
    },
  },
  {
    headerName: 'Code Domain Key',
    field: 'codeValueID.codeDomainKey',
    suppressMenu: false,
    minWidth: Styles.Width_180,
    sortable: true,

    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Code Value',
    field: 'codeValueID.codeValue',
    required: true,
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      disabled: true,
      required: true,
      maxLength: 10,
    },
    sortable: true,
    suppressMenu: false,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    minWidth: Styles.Width_180,
    maxWidth: Styles.Width_180,

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Short Description',
    field: 'shortDescription',
    cellRenderer: 'textFieldComponent',
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Long Description',
    field: 'longDescription',
    cellRenderer: 'textFieldComponent',
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
];
